import React, { useState } from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
} from '@mui/material'
import FeatureRequestCard from './FeatureRequestCard'
import VoteBalanceIndicator from './VoteBalanceIndicator'

const SUBCATEGORIES = [
  { value: 'all', label: 'Kaikki kategoriat' },
  { value: 'booking', label: 'Varaukset' },
  { value: 'payments', label: 'Maksut' },
  { value: 'reporting', label: 'Raportointi' },
  { value: 'customers', label: 'Asiakkaat' },
  { value: 'resources', label: 'Resurssit' },
  { value: 'activities', label: 'Aktiviteetit' },
  { value: 'communication', label: 'Viestintä' },
  { value: 'settings', label: 'Asetukset' },
  { value: 'other', label: 'Muu' },
]

const SORT_OPTIONS = [
  { value: 'votes', label: 'Eniten ääniä' },
  { value: 'newest', label: 'Uusimmat' },
]

function FeatureRequestList({
  requests,
  loading,
  voteBalance,
  userVotes,
  onVote,
}) {
  const [categoryFilter, setCategoryFilter] = useState('all')
  const [sortBy, setSortBy] = useState('votes')
  const [votingRequestId, setVotingRequestId] = useState(null)

  const handleVote = async (requestId, voteCount) => {
    setVotingRequestId(requestId)
    try {
      await onVote(requestId, voteCount)
    } finally {
      setVotingRequestId(null)
    }
  }

  const filteredRequests = requests
    .filter((r) => categoryFilter === 'all' || r.subcategory === categoryFilter)
    .sort((a, b) => {
      if (sortBy === 'votes') {
        return (b.voteCount || 0) - (a.voteCount || 0)
      }
      return b.created?.toMillis?.() - a.created?.toMillis?.() || 0
    })

  const getUserVotesForRequest = (requestId) => {
    const vote = userVotes.find((v) => v.requestId === requestId)
    return vote ? vote.voteCount : 0
  }

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box>
      <VoteBalanceIndicator
        totalVotes={voteBalance.totalVotes}
        usedVotes={voteBalance.usedVotes}
        remainingVotes={voteBalance.remainingVotes}
      />

      <Box display="flex" gap={2} my={2}>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Kategoria</InputLabel>
          <Select
            value={categoryFilter}
            label="Kategoria"
            onChange={(e) => setCategoryFilter(e.target.value)}
          >
            {SUBCATEGORIES.map((cat) => (
              <MenuItem key={cat.value} value={cat.value}>
                {cat.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel>Järjestys</InputLabel>
          <Select
            value={sortBy}
            label="Järjestys"
            onChange={(e) => setSortBy(e.target.value)}
          >
            {SORT_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {filteredRequests.length === 0 ? (
        <Box textAlign="center" py={4}>
          <Typography color="text.secondary">
            {categoryFilter !== 'all'
              ? 'Ei ominaisuustoiveita tässä kategoriassa'
              : 'Ei hyväksyttyjä ominaisuustoiveita'}
          </Typography>
        </Box>
      ) : (
        filteredRequests.map((request) => (
          <FeatureRequestCard
            key={request.id}
            request={request}
            userVotes={getUserVotesForRequest(request.id)}
            remainingVotes={voteBalance.remainingVotes}
            onVote={handleVote}
            isVoting={votingRequestId === request.id}
          />
        ))
      )}
    </Box>
  )
}

export default FeatureRequestList
